import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import SEO from '../components/SEO';
import './Auth.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const { data } = await axios.post(`${API_URL}/auth/forgot-password`, {
        email: email.trim()
      });
      setMessage(data.message || t('auth.forgotPasswordSuccess'));
    } catch (err) {
      const msg = err.response?.data?.message || t('auth.forgotPasswordError');
      if (err.response?.status === 500) {
        setError(msg);
      } else {
        setMessage(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <SEO title={t('auth.forgotPassword')} path="/forgot-password" noIndex />
      <div className="auth-card">
        <h2>{t('auth.forgotPassword')}</h2>
        <p className="auth-subtext">{t('auth.forgotPasswordInstructions')}</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.email')}</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); setMessage(''); }}
              required
              autoComplete="email"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t('auth.sending') || 'Sending...' : t('auth.sendResetLink')}
          </button>
        </form>
        <p className="auth-link">
          <Link to="/login">{t('auth.backToLogin')}</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
